<div fxLayout="row" fxLayoutAlign="end">
    <mat-button-toggle-group color="primary" #group="matButtonToggleGroup" value="Linux">
        <mat-button-toggle color="primary" value="Linux" aria-label="Text align left">
            Linux
        </mat-button-toggle>
        <mat-button-toggle color="primary" value="Windows" aria-label="Text align center">
            Windows
        </mat-button-toggle>
    </mat-button-toggle-group>

</div>


<div class="main-container" fxLayout="row" fxLayoutAlign="start" fxLayoutGap="5%">
    <div fxLayout="column" fxLayoutGap="5%" fxFlex="50">
        <h1 class="main-text">GET WESETH <br>CLIENT</h1>
        <h3 class="secondary-text">and access to the drivesec infrastructure today</h3>
        <button mat-raised-button color="primary" class="w-50 dw-button" (click)="showEula(group.value)">
            DOWNLOAD {{group.value | uppercase }} CLIENT
        </button>

        <mat-divider fxFlexOffset="1"></mat-divider>
        <div class="text-centered">
            <p class="trouble-text">
                Having trouble?
            </p>

            <p>Download <a [routerLink]="[]" (click)="showEula(group.value, false)">older version</a> of Weseth
                <b>{{group.value}}</b> client
            </p>

        </div>
    </div>
    <div fxLayout="column" fxFlex="40">
        <img src="/assets/client.png" alt="weseth-client">

    </div>

</div>


<div class="table-row">

    <h3 [ngStyle]="{'font-size':'30px'}">Weseth Client Features</h3>
    <h4>Not all features are available for both Linux and Windows. </h4>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> FEATURE </th>
            <td style="font-weight: 450; font-size: 17px" mat-cell *matCellDef="let element "> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> DESCRIPTION </th>
            <td style="font-weight: 350;font-size:14px; width: 30%; padding-top: 2%; padding-bottom: 2%" mat-cell
                *matCellDef="let element " [innerHTML]="element.description"></td>
        </ng-container>


        <ng-container matColumnDef="linux">
            <th mat-header-cell *matHeaderCellDef> LINUX </th>
            <td mat-cell *matCellDef="let element"> <mat-icon *ngIf="element.linux"
                    [ngStyle]="{'color':'green'}">check</mat-icon> </td>
        </ng-container>

        <ng-container matColumnDef="windows">
            <th mat-header-cell *matHeaderCellDef> WINDOWS </th>
            <td mat-cell *matCellDef="let element"><mat-icon *ngIf="element.windows"
                    [ngStyle]="{'color':'green'}">check</mat-icon> </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

</div>